
  import { Vue, Component } from 'vue-property-decorator';
  import { homeService, servicePromotion, userService } from '@/service/Index';
  import store from '@/store/index';
  import router from '@/router';
  import { setWrapHeight, setPageHeight } from '@/common/utils/index';
  @Component({
    components: {},
  })
  export default class App extends Vue {
    //获取当前url中的参数
    getQueryString(name: string) {
      let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      let r = window.location.search.substring(1).match(reg);
      if (r != null) {
        return encodeURI(r[2]);
      }
      return null;
    }
    isHeCheng = this.getQueryString('isHeCheng');
    heChengToken = this.getQueryString('token');
    pageHeight = 5000;
    //获取cpt入口配置信息
    getAuthoritySaleRequest() {
      homeService.getActivityKindsFn({}).then((res: any) => {
        // 清除持久化缓存
        store.commit('updateState', { key: 'cpcTrafficExpressIsShow', value: false });
        store.commit('updateState', { key: 'cpmModuleIsShow', value: false });
        if (res?.result?.data && res?.result?.data.length > 0) {
          res.result.data.forEach(function (item: any) {
            switch (item.kindId) {
              case 1:
                store.commit('updateState', { key: 'goldBoothIsShow', value: true });
                break;
              case 2:
                store.commit('updateState', { key: 'similarHotelIsShow', value: true });
                break;
              case 3:
                store.commit('updateState', { key: 'nearByIsShow', value: true });
                break;
              case 5:
                store.commit('updateState', { key: 'businessAreaIsShow', value: true });
                break;
              case 6:
                store.commit('updateState', { key: 'WeChatAdIsShow', value: true });
                break;
              case 7:
                store.commit('updateState', { key: 'trafficExpressIsShow', value: true });
                break;
              case 8:
                store.commit('updateState', { key: 'decorateIsShow', value: true });
                break;
              case 10:
                store.commit('updateState', { key: 'cpcTrafficExpressIsShow', value: true });
                break;
              case 12: //智能推荐
                store.commit('updateState', { key: 'intelligentRecommendIsShow', value: true });
                store.commit('updateState', { key: 'intelligentRecommendCanBooking', value: item.canBooking ? 1 : 0 });
                break;
              case 13: // 品牌广告
                store.commit('updateState', { key: 'brandAdIsShow', value: true });
                store.commit('updateState', { key: 'brandAdCanBooking', value: item.canBooking ? 1 : 0 });
                break;
              case 14:
                store.commit('updateState', { key: 'cpmModuleIsShow', value: true });
                break;
              case 16: // 市场活动
                store.commit('updateState', { key: 'marketActivityIsShow', value: item.canBooking ? true : false });
                break;
              case 17: // 聚意宝
                store.commit('updateState', { key: 'jiashuoActivityIsShow', value: true });
                break;
              case 20: // 流量风帆
                store.commit('updateState', { key: 'showCpsModule', value: true });
                break;
              default:
            }
          });
        }
      });
    }
    //获取常量配置
    getCommonConfig() {
      servicePromotion.getCommonConfig().then((res: any) => {
        if (res?.code == 0 && res?.data) {
          res?.data.commentScore && store.commit('updateState', { key: 'commentScore', value: res?.data.commentScore });

          res?.data.hotelImageCount &&
            store.commit('updateState', { key: 'hotelImageCount', value: res?.data.hotelImageCount });
        }
      });
    }
    // 获取商服电话
    async getEbkPromptMailbox() {
      const res = (await userService.queryEbkLoginPromptMailboxFn()) || {}
      if (res.code === 0 && res.data) {
        const mailboxInfo = {
          businessServiceMobile: res.data.businessServiceMobile,
          groupAdministratorMailbox: res.data.groupAdministratorMailbox,
          invoicingContactMailbox: res.data.invoicingContactMailbox,
        }
        store.commit('setMailboxInfo', mailboxInfo)
      }
    }
    created() {
      if (this.heChengToken) {
        this.$store.commit('setIsHeChengToken', this.heChengToken);
        this.$store.commit('setIsHeCheng', true);
      } else {
        this.$store.commit('setIsHeCheng', false);
      }
      this.getAuthoritySaleRequest();
      this.getCommonConfig();
      this.getEbkPromptMailbox();
    }
    mounted() {
      router.afterEach((to, from) => {
        if (!this.heChengToken) {
          setWrapHeight(this.$refs.pageWrap);
        }
      });
    }
  }
